module.exports = __webpack_public_path__ + "static/media/AC08004D_01.1c7c593d.png";